/**
 * Copyright 2004-present Facebook. All Rights Reserved.
 *
 * @generated SignedSource<<13a215ff5a28ab898cfff95502526217>>
 *
 * Generated by LanguageCLDRGenScript
 *
 * 
 */
'use strict';

var IntlVariations = require("./IntlVariations");

var IntlCLDRNumberType21 = {
  getVariation: function getVariation(n) {
    if (n === 1 || n === 11) {
      return IntlVariations.NUMBER_ONE;
    } else if (n === 2 || n === 12) {
      return IntlVariations.NUMBER_TWO;
    } else if (n >= 3 && n <= 10 || n >= 13 && n <= 19) {
      return IntlVariations.NUMBER_FEW;
    } else {
      return IntlVariations.NUMBER_OTHER;
    }
  }
};
module.exports = IntlCLDRNumberType21;